export const ROUTES = {
  HOME: '/',
  AUTH: {
    LOGIN: '/login',
    LOGIN_CODE: '/login/code',
  },
  PAYWALL: {
    V1: '/paywall/v1',
    V2: '/paywall/v2',
    V3: '/paywall/v3',
    V4: '/paywall/v4',
    V5: '/paywall/v5',
    V6: '/paywall/v6',
    V7: '/paywall/v7',
    V8: '/paywall/v8',
    V9: '/paywall/v9',
  },
  INSTALL: {
    V1: '/install/v1',
  },
  PAYMENT: {
    INDEX: '/payment',
  },
  ACCOUNT: {
    SUBSCRIPTION: '/account/subscription',
  },
  POLICY: {
    INDEX: '/policy',
    TERMS: '/policy/terms',
    PRIVACY: '/policy/privacy',
    SUBSCRIPTION: '/policy/subscription',
    FEEDBACK: '/policy/feedback',
  },
  TEST_WEBVIEW: '/test-webview',
} as const;

export const PROTECTED_ROUTES = [
  ROUTES.ACCOUNT.SUBSCRIPTION,
  ROUTES.PAYMENT.INDEX,
];
